var review = {
    loginUrl: "/sso/member/login",  //로그인 url
    prefixReviewUrl : "/mkt/review/",       //리뷰 화면 prefix
    prefixReviewApiUrl : "/mkt/api/review/",    //리뷰 api prefix
    reviewArea : null, //리뷰 영역
    reviewMoreBtnArea:null,     //더보기 버튼 영역
    realSearchParam:null,       //실조회 parameter
    //parameter
    param:{
        // unifyId : unifyId,
        memberInfoFlag: true,
        // options : "",
        pageIdx: 1,
        pageOrder: "",
        reviewFilterParam : {
            reviewOptionList : [],
            reviewTypeList : [],
            scoreList : [],
            sourceGubunList : []
        }
    },
    callAjax:function(callParam,param,callback){
        var type = callParam.type ? callParam.type : "POST";
        var contentType = callParam.contentType ? callParam.contentType : "application/json; charset=UTF-8;";
        var enctype = callParam.enctype ? callParam.enctype : "";
        var processData = callParam.processData ? callParam.processData : "";
        var async = callParam.async ? callParam.async : true;
        lgkorUI.showLoading();
        $.ajax({
            url: callParam.url,
            type: type,
            data: param,
            contentType: contentType,
            enctype : enctype,
            processData : processData,
            async : async,
            success: function (data) {
                if (typeof callback == 'function') {
                    callback(data);
                }
                lgkorUI.hideLoading();
            },
            error: function (e) {
                console.log(e);
                lgkorUI.hideLoading();
            }
        });
    },
    goPage: function(url){
        location.href=url;
    },
    init : function(){
        // console.log("=============> review.js init");
        review.reviewArea = $("#reviewArea");
        reviewMoreBtnArea = review.reviewArea.find("#reviewMoreBtnArea");
        if(Number(review.reviewArea.find("#reviewsCount").val()) > 0){
            this.conReviewMoreBtn();    //더보기버튼 control
            this.setPageOrderEvent();   //정렬 click event
            this.setOptionEvent();   //option
        }
        this.setParentReviewData();
    },
    getUrl: function (call, modelId) {
        return review.prefixReviewUrl + modelId + "/" + call;
    },
    setParentReviewData:function(){
        var score = review.reviewArea.find("#reviewScore").html();
        var reviewCount = review.reviewArea.find("#reviewCount").html();
        if(!score){
            score = '0';
        }
        if(!reviewCount){
            reviewCount = '(0)';
        }
        //최상단 별점,리뷰count
        var topReviewArea = $('.product-detail-info').find('.review-info');
        if(topReviewArea){
            topReviewArea.find('.scope').html(score + ' ' + reviewCount);
        }

        //중간 tab 리뷰count
        var tabArea = $("a[data-link-name='review']");
        if(tabArea){
            tabArea.find('span').html(reviewCount);
        }
    },
    //조회 getParameter
    getSearchParam: function (pageIdx) {
        var param = (reviewFilterLayer.getFilterParam())? reviewFilterLayer.getFilterParam() : review.param;
        if(pageIdx){
            param.pageIdx = pageIdx;
        }
        var pageOrder = review.reviewArea.find("#pageOrder option:selected").val();
        param.pageOrder = pageOrder;

        // console.log("getSearchParam",param);
        this.realSearchParam = JSON.parse(JSON.stringify(param));
        return param;
    },
    //리뷰목록 ajax
    getReviewModule: function (pageIdx, callback) {
        var url = this.getUrl("reviewModule", review.reviewArea.get(0).dataset.modelId);
        // var param = review.getSearchParam(pageIdx);
        var param = review.param;
        if(review.realSearchParam){
            param = review.realSearchParam;
        }
        param.pageIdx = pageIdx;
        param.modelDisplayname = review.reviewArea.get(0).dataset.modelDisplayname ? review.reviewArea.get(0).dataset.modelDisplayname : "";
        review.callAjax({
            url : url
        },JSON.stringify(param),function(data){
            callback(data);
        });
    },
    //리뷰 더보기 버튼 control
    conReviewMoreBtn : function(pageIdx){
        setTimeout(function(){
            //리뷰 전체 더보기 버튼
            pageIdx = pageIdx ? pageIdx : 1;
            var nextPageIdx = pageIdx + 1;
            var reviewMoreBtn = reviewMoreBtnArea.find("#reviewMoreBtn").get(0);
            var rowsPerPage = reviewMoreBtn.dataset.pageIdx ? Number(reviewMoreBtn.dataset.rowsPerPage) : 10;
            var reviewCount = reviewMoreBtn.dataset.reviewCount ? Number(reviewMoreBtn.dataset.reviewCount) : 0;
            // console.log("conReviewMoreBtn",rowsPerPage,reviewCount,pageIdx,nextPageIdx);
            if (reviewCount <= (rowsPerPage * pageIdx)) {
                reviewMoreBtnArea.hide();
            } else {
                reviewMoreBtnArea.show();
                reviewMoreBtn.dataset.pageIdx = nextPageIdx;
            }
        },1000);
    },
    //리뷰 더보기 버튼 click
    reviewMoreBtn: function (obj) {
        var pageIdx = obj.dataset.pageIdx ? Number(obj.dataset.pageIdx) : 1;
        if(review.realSearchParam){
        }else{
            review.realSearchParam = review.param;
        }
        review.getReviewModule(pageIdx, function (data) {
            review.reviewArea.find(".product-review-list").append(data);
            review.conReviewMoreBtn(pageIdx);
        });
    },
    //정렬 event
    setPageOrderEvent: function(){
        review.reviewArea.find("#pageOrder").on("change",function(e){
            var pageOrder = review.reviewArea.find("#pageOrder option:selected").val();
            if(review.realSearchParam){
            }else{
                review.realSearchParam = review.param;
            }
            review.realSearchParam.pageOrder = pageOrder;
            review.getReviewModule(1, function (data) {
                review.reviewArea.find(".product-review-list").html(data);
                review.conReviewMoreBtn(1);
            });
        });
    },
    //리뷰 작성 팝업
    reviewFormPopup: function (obj) {
        reviewPopup.reviewFormPopup({
            reviewId :  obj.dataset.reviewId,
            modelId : obj.dataset.modelId,
            reviewPath : obj.dataset.reviewPath
            // obsOrderNo : 'TEST_OBS_ORDER_NO',
            // gerpOrdNo : 'TEST_GERP_ORD_NO'
            //,b2cYN : 'N'
        });
    },
    //바닥 페이지 option event
    setOptionEvent: function(){
        var optionList = review.reviewArea.find("#optionList").find("input[type='checkbox']");
        $.each(optionList,function(idx,item){
            $(item).on("change",function(e){
                reviewFilterLayer.setFilterData();
                var target = $(e.target);
                var id = "option-" + target.get(0).id.split("-")[1];
                var txt = reviewFilterLayer.reviewFilterArea.find("label[for='"+id+"']").get(0).innerText;
                reviewFilterLayer.setSelectFilter(id,txt,"search",true);
            });
        });
    },
    //추천
    saveRecommand: function (obj) {
        var param = {
            reviewId: obj.dataset.reviewId,
            useFlag: (obj.dataset.recommandOwnCount > 0) ? "N" : "Y"
        };

        review.callAjax({
                url : review.prefixReviewApiUrl+"saveRecommand"
            },
            JSON.stringify(param),
            function(data){
                // console.log(data);
                if (data.resultCode == "SUCCESS") {
                    var recommand = data.reviewRecommand;
                    obj.dataset.recommandCount = recommand.recommandCount;
                    $(obj).parent().find(".count").html(recommand.recommandCount);
                    if (param.useFlag == "N") {
                        obj.dataset.recommandOwnCount = 0;
                        $(obj).parent().removeClass("on");
                    } else {
                        obj.dataset.recommandOwnCount = 1;
                        $(obj).parent().addClass("on");
                    }
                } else if (data.resultCode == "NOT_LOGIN") {
                    lgkorUI.confirm("로그인 후 추천이 가능합니다.<br>로그인 하시겠습니까? ", {
                        title: "",
                        cancelBtnName: "아니요",
                        okBtnName: "네",
                        ok:function(){
                            review.goPage(review.loginUrl);
                        }
                    });
                }
            }
        );
    },
    //신고하기 팝업
    declairForm: function (e) {
        var reviewId = e.dataset.reviewId;
        if(!vcui.isEmpty(reviewId)){
            reviewPopup.reviewDeclairFormPopup({
                reviewId :  reviewId,
            });
        }
    }
}

//리뷰 filter layer
var reviewFilterLayer = {
    reviewFilterArea:null,  //리뷰 filter 영역
    filterData:null,    //선택된 필터 data
    init:function(){
        this.reviewFilterArea = $("#reviewFilterLayer");
        this.filterData = this.reviewFilterArea.find("#filterData");
        this.setFilterClick();  //filter 선택 click event
        this.getFilterCount();  //선택된 filter count
        this.setFilterClose();
    },
    //filter layer open시 event
    openLayer : function(){
        this.setFilterData();
        this.getFilterCount();
    },
    setFilterData : function(){
        this.resetFilter(false);
        // console.log("openLayer",review.realSearchParam);
        if(review.realSearchParam){
            var filterParam = review.realSearchParam.reviewFilterParam;
            filterParam.reviewOptionList.forEach(function(value,idx){
                // console.log("reviewOptionList",value);
                var id = "option-"+value.optNum+"_"+value.optItemId+"_"+value.optItemValueId;
                var label = reviewFilterLayer.reviewFilterArea.find("label[for^=\""+id+"\"]");
                var checkbox = reviewFilterLayer.reviewFilterArea.find("#"+id);
                checkbox.prop("checked",true);
                reviewFilterLayer.setSelectFilter(label.get(0).htmlFor,label.get(0).innerText,null,false);
            });
            filterParam.reviewTypeList.forEach(function(value,idx){
                var label = reviewFilterLayer.reviewFilterArea.find("label[for^=\""+value+"\"]");
                var checkbox = reviewFilterLayer.reviewFilterArea.find("input[id^=\""+value+"\"]");
                checkbox.prop("checked",true);
                reviewFilterLayer.setSelectFilter(label.get(0).htmlFor,label.get(0).innerText,null,false);
            });
            filterParam.scoreList.forEach(function(value,idx){
                // console.log("scoreList",value);
                var id = "score-"+value.score + "_" + value.scoreType;
                var label = reviewFilterLayer.reviewFilterArea.find("label[for=\""+id+"\"]");
                var checkbox = reviewFilterLayer.reviewFilterArea.find("#"+id);
                checkbox.prop("checked",true);
                reviewFilterLayer.setSelectFilter(label.get(0).htmlFor,label.get(0).innerText,null,false);
            });
            filterParam.sourceGubunList.forEach(function(value,idx){
                // console.log("sourceGubunList",value);
                var id = "sourceGubun-"+value;
                var label = reviewFilterLayer.reviewFilterArea.find("label[for=\""+id+"\"]");
                var checkbox = reviewFilterLayer.reviewFilterArea.find("#"+id);
                checkbox.prop("checked",true);
                reviewFilterLayer.setSelectFilter(label.get(0).htmlFor,label.get(0).innerText,null,false);
            });

        }
    },
    //filter 선택시 event
    setFilterClick: function(){
        // var filterCheckboxList = reviewFilterLayer.reviewFilterArea.find("label");
        var filterCheckboxList = reviewFilterLayer.reviewFilterArea.find("input[type='checkbox']");
        $.each(filterCheckboxList,function(idx,item){
            $(item).on("change",function(e){
                var target = $(e.target);
                var id = target.get(0).id;
                var txt = reviewFilterLayer.reviewFilterArea.find("label[for='"+id+"']").get(0).innerText;
                reviewFilterLayer.setSelectFilter(id,txt,null,true);
            });
        });

        var filterCmInchBtn = reviewFilterLayer.reviewFilterArea.find(".btn-change-unit");
        $.each(filterCmInchBtn,function(idx,el){
           $(el).on("click",function(e){
               var obj = e.target;
               if($(obj).is('span')){
                   obj = $(e.target).parent();
               }
              reviewFilterLayer.calcCmInch(obj);
           });
        });
    },
    //선택된 filter 정보 세팅 -> filterData
    setSelectFilter : function(id,txt,type,isSearchCount){
        // console.log(id,txt,type,isSearchCount);
        var data = reviewFilterLayer.filterData.find("li[data-id='" + id + "']");
        if(data.length > 0 || type == 'delete'){
            data.remove();
        }else{
            var selectFilterTemplate = '<li data-id="_id">\n' +
                '                    <div class="s-fliter">\n' +
                '                        <span>_title</span>\n' +
                '                           <button type="button" class="btn-del" onclick="javascript:reviewFilterLayer.deleteFilter(\'_id\',\'true\');"' +
                '                           >' +
                '                               <span class="blind">삭제</span>' +
                '                           </button>\n' +
                '                    </div>\n' +
                '                </li>';

            selectFilterTemplate = selectFilterTemplate.replaceAll("_id",id).replaceAll("_title",txt);
            reviewFilterLayer.filterData.append(selectFilterTemplate);
        }
        if(isSearchCount){
            this.getFilterCount(function(){
                if(type == "search"){
                    reviewFilterLayer.getReviewListFilter(type);
                }else{
                    lgkorUI.hideLoading();
                }
            });
        }
    },
    setFilterClose : function(){
        reviewFilterLayer.reviewFilterArea.find(".btn-close").off().on('click',function(e){
            reviewFilterLayer.setFilterData();
            $('reviewFilterLayer').vcModal('close');
        });
    },
    //선택된 filter 삭제
    deleteFilter : function(id,searchFlag){
        var checkbox = reviewFilterLayer.reviewFilterArea.find("#"+id);
        checkbox.prop("checked",false);
        this.setSelectFilter(id,null,"delete",searchFlag);
    },
    //filter 초기화
    resetFilter : function(searchCountFlag){
        if(reviewFilterLayer.filterData){
            reviewFilterLayer.filterData.html("");
        }
        var filterCheckboxList = reviewFilterLayer.reviewFilterArea.find("label");
        $.each(filterCheckboxList,function(idx,item){
            reviewFilterLayer.deleteFilter(item.htmlFor,false);
        });
        if(searchCountFlag){
            this.getFilterCount();
        }
    },
    //컬러 필터 초기화
    resetColorFilter : function(){
        // $.each(reviewFilterLayer.filterData.find("li[data-id^='option-']"),function(idx,el){
        //     // console.log($(el).get(0).dataset.id);
        //     reviewFilterLayer.deleteFilter($(el).get(0).dataset.id,false);
        // });
        reviewFilterLayer.resetFilter(false);
        var reviewMoreBtn = reviewMoreBtnArea.find("#reviewMoreBtn").get(0);
        reviewMoreBtn.dataset.reviewCount = review.reviewArea.find("#reviewsCount").val();
        review.realSearchParam = review.param;
        review.getReviewModule(1, function (data) {
            review.reviewArea.find(".product-review-list").html(data);
            review.conReviewMoreBtn(1);

            var filterCount = review.reviewArea.find("#filterCount");
            filterCount.hide();
            review.reviewArea.find("#filterCount").text(0);

            reviewFilterLayer.setOpenerOption();
        });
    },
    //각 filter 영역별 count
    setFilterTypeCount:function(){
        var optionFilterCount = 0;
        var scoreFilterCount = 0;
        var reviewTypeFilterCount = 0;
        var sourceGubunFilterCount = 0;
        $.each(reviewFilterLayer.filterData.find("li"),function(idx,item){
            // console.log(item);
            // console.log(item.dataset.id);

            var id = item.dataset.id.split("-");
            var key = id[0];
            switch (key){
                case 'option' :
                    optionFilterCount++;
                    break;
                case 'score' :
                    scoreFilterCount++;
                    break;
                case 'sourceGubun' :
                    sourceGubunFilterCount++;
                    break;
                case 'bestFlag' :
                case 'expFlag' :
                case 'normalFlag' :
                case 'photoVideoFlag' :
                    reviewTypeFilterCount++;
                    break;
            }
        });

        var totalFilterCount = optionFilterCount + scoreFilterCount + reviewTypeFilterCount + sourceGubunFilterCount;

        var optionCountList = reviewFilterLayer.reviewFilterArea.find("span[id^='optionFilterCount-']");
        $.each(optionCountList,function(idx,el){
            var parentEl = $(el).parent().parent();
            var optionCount = parentEl.find('input:checkbox[name="option"]:checked').length;
            if(optionCount > 0){
                $(el).html('<span class="blind">선택된 옵션 개수</span>'+optionCount); //  BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 : text에서 append 변경함.
                //$(el).text(optionCount);
            }else{
                $(el).text("");
            }
        })
        if(scoreFilterCount > 0){
            reviewFilterLayer.reviewFilterArea.find("#scoreFilterCount").html('<span class="blind">선택된 옵션 개수</span>'+scoreFilterCount);
        }else{
            reviewFilterLayer.reviewFilterArea.find("#scoreFilterCount").text("");
        }
        if(reviewTypeFilterCount > 0){
            reviewFilterLayer.reviewFilterArea.find("#reviewTypeFilterCount").html('<span class="blind">선택된 옵션 개수</span>'+reviewTypeFilterCount);
        }else{
            reviewFilterLayer.reviewFilterArea.find("#reviewTypeFilterCount").text("");
        }
        if(sourceGubunFilterCount > 0){
            reviewFilterLayer.reviewFilterArea.find("#sourceGubunFilterCount").html('<span class="blind">선택된 옵션 개수</span>'+sourceGubunFilterCount);
        }else{
            reviewFilterLayer.reviewFilterArea.find("#sourceGubunFilterCount").text("");
        }
        var filterWrap = reviewFilterLayer.reviewFilterArea.find(".select-fliter-wrap");
        if(totalFilterCount == 0){
            filterWrap.hide();
        }else{
            filterWrap.show();
        }
    },
    //선택된 filter getParameter
    getFilterParam : function(){
        var param = JSON.parse(JSON.stringify(review.param));
        $.each(reviewFilterLayer.filterData.find("li"),function(idx,item){
            // console.log(item);
            // console.log(item.dataset.id);
            var id = item.dataset.id.split("-");
            var key = id[0];
            var value = id[1];
            switch (key){
                case 'option' :
                    var valueData = value.split("_");
                    param.reviewFilterParam.reviewOptionList.push({
                        "optNum" : valueData[0],
                        "optItemId" : valueData[1],
                        "optItemValueId" : valueData[2]
                    });
                    break;
                case 'score' :
                    var valueData = value.split("_");
                    param.reviewFilterParam.scoreList.push({
                        "scoreType" : valueData[1],
                        "score" : valueData[0]
                    });
                    break;
                case 'sourceGubun' :
                    param.reviewFilterParam.sourceGubunList.push(value);
                    break;
                case 'bestFlag' :
                case 'expFlag' :
                case 'normalFlag' :
                case 'photoVideoFlag' :
                    param.reviewFilterParam.reviewTypeList.push(key);
                    break;
            }
        });

        return param;
    },
    //선택된 filter 리뷰 건수조회
    getFilterCount: function(callback){
        this.setFilterTypeCount();
        var param = this.getFilterParam();
        var url = review.prefixReviewApiUrl+review.reviewArea.get(0).dataset.modelId+"/reviewFilterCount";

        // lgkorUI.showLoading();
        $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(param),
            contentType: "application/json; charset=UTF-8;",
            success: function (data) {
                // console.log(data);
                if(data.resultCode == "SUCCESS"){
                    var reviewFilterCount = reviewFilterLayer.reviewFilterArea.find("#reviewFilterCount");
                    var reviewFilterBtn = reviewFilterCount.parent();
                    reviewFilterCount.get(0).dataset.reviewCount=data.reviewCount;
                    if(data.reviewCount == 0){
                        reviewFilterBtn.attr("disabled",true);
                        reviewFilterLayer.reviewFilterArea.find("#reviewFilterCount").text("조건에 맞는 리뷰가 없어요");
                    }else{
                        reviewFilterBtn.attr("disabled",false);
                        reviewFilterLayer.reviewFilterArea.find("#reviewFilterCount").text(data.reviewCount + "개의 리뷰 보기");
                    }

                    // console.log(callback);
                    if(typeof callback == 'function'){
                        callback();
                    }else{
                        // lgkorUI.hideLoading();
                    }
                }
            },
            error: function (e) {
                console.log(e);
                // lgkorUI.hideLoading();
            }
        });
    },
    //filter layer close
    closeFilterLayer:function(){
        reviewFilterLayer.reviewFilterArea.find(".btn-close").click();   //filter layer 닫기
    },
    //선택된 filter 리뷰 조회
    getReviewListFilter: function(type){
        var reviewMoreBtn = reviewMoreBtnArea.find("#reviewMoreBtn").get(0);
        var reviewFilterCount = reviewFilterLayer.reviewFilterArea.find("#reviewFilterCount");
        var reviewCount = reviewFilterCount.get(0).dataset.reviewCount;
        reviewMoreBtn.dataset.reviewCount = reviewCount;
        review.getSearchParam(1);
        review.getReviewModule(1, function (data) {
            review.reviewArea.find(".product-review-list").html(data);
            review.conReviewMoreBtn(1);

            var filterCount = review.reviewArea.find("#filterCount");
            var totalFilterCount = reviewFilterLayer.filterData.find("li").length;
            if(totalFilterCount > 0){
                filterCount.show();
                review.reviewArea.find("#filterCount").text(totalFilterCount);
            }else{
                filterCount.hide();
                review.reviewArea.find("#filterCount").text(0);
            }

            reviewFilterLayer.setOpenerOption();
            // console.log(type);
            if(type == 'search'){

            }else{
                reviewFilterLayer.closeFilterLayer();
            }
        });
    },
    // filter에서 검색후 바닥 option 세팅
    setOpenerOption:function(){
        var optionList = review.reviewArea.find("#optionList").find("label[for^='optionPage-']");
        $.each(optionList,function(idx,item){
            var id = item.htmlFor;
            var paramId = id.split("-")[1];
            var paramData = reviewFilterLayer.filterData.find("li[data-id='option-"+paramId+"']");
            var checkbox = review.reviewArea.find("#optionList").find("#"+id);
            if(paramData != null && paramData.length > 0){
                checkbox.prop("checked",true);
            }else{
                checkbox.prop("checked",false);
            }
        });
    },
    calcCmInch:function(obj){
        var id = $(obj).get(0).dataset.itemGroup;
        var filter = reviewFilterLayer.reviewFilterArea.find("label[for^='"+id+"']");
        var isCm = false;
        if($(obj).hasClass('is-inch') === true){
            isCm = true;
        }
        $.each(filter,function(idx,el){
            var size = $(el).get(0).dataset.optItemValueDispNm;
            var inchSize = $(el).get(0).dataset.optItemValueNm;
            var filterDataId = $(el).get(0).htmlFor;
            var filterData = reviewFilterLayer.filterData.find("li[data-id='"+filterDataId+"']");

            var txtSize = '';
            if(isCm == true){
                txtSize = size;
            }else{
                txtSize = size + ' ('+ inchSize + ' inch' + ')';
            }
            $(el).text(txtSize);
            if(filterData){
                filterData.find('span').text(txtSize);
            }
        })
    }
}

$(function(){
    review.init();  //리뷰
    reviewFilterLayer.init();   //리뷰 필터
});

